<template>
  <div class="div-more">
    <router-link v-if="moreType == 'object'" :to="link" tag="a">
      {{ more }} <img src="../../assets/img/more.png" />
    </router-link>
    <a :href="link" v-if="moreType == 'string'"
      >{{ more }} <img src="../../assets/img/more.png"
    /></a>
    <h1>{{ title }}</h1>
  </div>
</template>
<script>
export default {
  data() {
    return {
      moreType: ""
    };
  },
  props: ["title", "more", "link"],
  created() {
    this.moreType = typeof this.$props.link;
  }
};
</script>
<style lang="less">
.div-more {
  h1 {
    color: #eb565a;
    font-size: 24px;
    margin: 0;
    height: 100%;
    line-height: 24px;
  }
  a {
    justify-content: center;
    align-items: center;
    float: right;
    font-size: 18px;
    font-weight: 400;
    color: rgba(0, 113, 255, 1);
    // background-image: url('../../assets/img/more.png');
    // background-repeat: no-repeat;
    // background-position: right center;
    // background-size:contain 60% ;
    // padding-right:30px;
    height: 18px;
img {
        margin-left: 3px;
        margin-top:-2px;
        height: 80%;
      }
  }
  height: 25px;
  line-height: 25px;
  overflow: hidden;
  margin-top: 60px;
  margin-bottom: 40px;
}
@media (max-width: 768px) {
  .div-more {
    h1 {
      color: #eb565a;
      font-size: 14px;
      margin: 0;
    }
    a {
      float: right;
      font-size: 12px;
      font-weight: 400;
      color: rgba(0, 113, 255, 1);
      height: 14px;
      img {
        margin-left: 3px;
        margin-top:-2px;
        height: 60%;
      }
    }
    height: 25px;
    line-height: 25px;
    overflow: hidden;
    margin-top: 20px !important;
    margin-bottom: 10px !important;
  }
}
</style>